import { createSelector } from 'reselect'
import { parseISOToDateTime } from '@calendly/datetime'
import { parseQuery } from '@calendly/http-tools'

const calendarSelector = (state) => state.calendar

const calendarDayRawSelector = (state) => state.calendar.day

export const daySelector = createSelector(
  calendarDayRawSelector,
  (day) => {
    if (!day) return null
    return { ...day, date: parseISOToDateTime(day.date) }
  }
)

export const calendarWithParsedDaySelector = createSelector(
  calendarSelector,
  (calendar) => {
    if (!calendar.day) return calendar
    return {
      ...calendar,
      day: { ...calendar.day, date: parseISOToDateTime(calendar.day.date) }
    }
  }
)

export const monthShiftSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.monthShift
)

export const initialMonthParamSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.initialMonthParam
)

export const spotTimeForConflictsSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.conflictCheckQueue[0]
)

export const utcTodaySelector = createSelector(
  calendarSelector,
  (calendar) => parseISOToDateTime(calendar.today)
)

export const selectedSpotsSelector = createSelector(
  calendarSelector,
  (calendar) => calendar.selectedSpots
)

const hideDetails = ({ hide_event_type_details: hideEtDetails }) => parseInt(hideEtDetails, 10) === 1
export const hideEventTypeDetailsSelector = () => hideDetails(parseQuery(window.location.search))
